var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup48095511(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 37,
    viewBox: "0 0 53 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 10.5,
    r: 25.5,
    fill: "#E6F7FF",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7882 13.5C39.7882 20.9559 33.9559 27 26.5 27C24.272 27 22.17 26.4603 20.3177 25.5044C18.3569 24.4925 16.8877 22.7497 15.6331 20.9519C14.6917 19.6029 13.7787 18.3386 13.3794 16.6915C13.1315 15.6683 13 14.5995 13 13.5C13 6.04414 19.0441 0 26.5 0C32.2836 0.0377471 39.7882 6.04414 39.7882 13.5Z",
    fill: "url(#paint0_linear_715_336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 0C26.1434 0 25.7902 0.0140824 25.4406 0.0411882C30.7922 0.456618 35.2679 3.99256 37.0516 8.83133C37.0497 8.83477 37.0477 8.83768 37.0459 8.84123C35.6654 11.4931 33.3151 14.5426 30.4288 17.4289C27.5426 20.3151 24.4924 22.6654 21.8413 24.0459C20.8519 24.5607 20.0713 24.8605 19.4691 25.0264C20.6195 25.7296 21.8835 26.265 23.2269 26.5996C26.1238 25.0835 29.4087 22.5582 32.4835 19.4834C34.5865 17.3804 36.432 15.1792 37.8738 13.0711C37.8782 13.2135 37.8813 13.3564 37.8813 13.4999C37.8813 20.5993 32.4013 26.4184 25.4407 26.9588C25.7902 26.9859 26.1434 27 26.5 27C29.9654 27 33.1259 25.6942 35.5163 23.5479C36.3935 22.7602 37.09 21.7838 37.7367 20.7926C38.4707 19.668 39.1184 18.5028 39.4925 17.1795C39.8231 16.0098 40 14.7756 40 13.5C40 10.113 38.7527 7.01741 36.6924 4.64734C35.6096 3.40168 34.1433 2.51524 32.6743 1.73351C30.7856 0.728365 28.7887 0 26.5 0Z",
    fill: "url(#paint1_linear_715_336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3329 13.6967L20.4459 12.8097C18.8068 11.1706 16.1493 11.1706 14.5102 12.8097C13.4752 13.8448 13.0458 15.3463 13.3989 16.7669C14.2567 20.2185 16.4426 23.145 19.383 24.9728C20.9115 25.923 22.8917 25.7024 24.1643 24.4298C24.8236 23.7704 25.7179 23.4 26.6503 23.4C27.806 23.4 28.7428 22.4632 28.7428 21.3075C28.7428 19.4344 27.2244 17.9159 25.3512 17.9159H24.5283C23.1634 17.9159 22.0568 16.8093 22.0568 15.4443C22.0568 14.7888 21.7964 14.1602 21.3329 13.6967Z",
    fill: "url(#paint2_linear_715_336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1643 24.4298C24.8236 23.7704 25.7179 23.4 26.6503 23.4C27.806 23.4 28.7428 22.4631 28.7428 21.3075C28.7428 20.6443 28.5518 20.0261 28.2228 19.5034C26.0294 21.4389 23.8238 23.0136 21.8413 24.0459C20.8536 24.5599 20.0739 24.8595 19.4721 25.0256C20.9879 25.9133 22.9161 25.6779 24.1643 24.4298Z",
    fill: "url(#paint3_linear_715_336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0083 12.3353C37.8434 12.3353 39.6348 9.27244 38.2281 6.81099C35.903 2.74225 31.522 0 26.5 0C26.4577 0 26.4154 0.000211765 26.3732 0.000582353C24.8316 0.0148765 23.5883 1.26619 23.5883 2.80789C23.5883 3.55235 23.884 4.26632 24.4104 4.79271L26.9168 7.29916C27.6009 7.98321 28.7099 7.98321 29.394 7.29916C30.0781 6.61511 31.1871 6.61511 31.8712 7.29916C32.8825 8.31049 33.4507 9.6822 33.4507 11.1125C33.4507 11.7878 33.9981 12.3352 34.6735 12.3352H35.0083V12.3353Z",
    fill: "url(#paint4_linear_715_336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7715 0.0714706C30.9761 0.604006 35.3049 4.09267 37.0516 8.83138C37.0497 8.83482 37.0477 8.83774 37.0458 8.84128C36.4686 9.95008 35.7214 11.1285 34.8368 12.3353H35.0082C37.8433 12.3353 39.6347 9.27244 38.2281 6.81099C35.903 2.74225 31.522 0 26.5 0C26.4487 0 26.3976 0.000952941 26.3464 0.00153529C26.1491 0.00518824 25.9569 0.0292765 25.7715 0.0714706Z",
    fill: "url(#paint5_linear_715_336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3955 14.0956C31.5356 14.0956 32.4598 13.1714 32.4598 12.0313C32.4598 10.8912 31.5356 9.96692 30.3955 9.96692C29.2554 9.96692 28.3312 10.8912 28.3312 12.0313C28.3312 13.1714 29.2554 14.0956 30.3955 14.0956Z",
    fill: "url(#paint6_linear_715_336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9706 10.7073C17.9103 10.7073 18.6721 9.94556 18.6721 9.00586C18.6721 8.06616 17.9103 7.30438 16.9706 7.30438C16.0309 7.30438 15.2691 8.06616 15.2691 9.00586C15.2691 9.94556 16.0309 10.7073 16.9706 10.7073Z",
    fill: "url(#paint7_linear_715_336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4923 17.1794H38.0481C36.4674 17.1794 34.9515 17.8073 33.8338 18.925L32.3906 20.3682C31.8189 20.94 32.2239 21.9176 33.0325 21.9176C33.5473 21.9176 33.9647 22.335 33.9647 22.8499C33.9647 23.6539 34.9176 24.0844 35.5158 23.5473C37.3885 21.8659 38.7887 19.669 39.4923 17.1794Z",
    fill: "url(#paint8_linear_715_336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0481 17.1794C37.8175 17.1794 37.5883 17.1931 37.3615 17.2195C36.7294 19.4292 35.5486 21.4068 33.9755 22.996C34.0824 23.7039 34.9549 24.0509 35.5158 23.5473C37.3885 21.866 38.7886 19.669 39.4923 17.1794H38.0481V17.1794Z",
    fill: "url(#paint9_linear_715_336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.715 1.28493C37.7898 0.359672 35.9347 -0.330575 32.2885 1.30107C33.4023 1.8299 34.4322 2.50723 35.3523 3.30786C35.6609 3.24396 35.9095 3.22003 36.1045 3.22003C36.2685 3.22003 36.3944 3.23681 36.4855 3.26006C36.5772 3.2833 36.634 3.313 36.6605 3.33947C36.7444 3.42401 36.8639 3.81922 36.6921 4.64759C36.5591 5.2894 36.2511 6.1921 35.6164 7.41176C34.2359 10.0636 31.8856 13.1131 28.9994 15.9994C26.1132 18.8856 23.063 21.2359 20.4118 22.6164C19.1921 23.2511 18.2894 23.5591 17.6476 23.6921C16.8192 23.8639 16.4241 23.7444 16.3395 23.6605C16.2555 23.5759 16.1361 23.1807 16.3078 22.3523C15.5072 21.4322 14.8298 20.4024 14.301 19.2885C12.6694 22.9347 13.3596 24.7891 14.2849 25.7151C14.8059 26.2355 15.6208 26.6823 16.8837 26.6823C17.8645 26.6823 19.1165 26.4124 20.7107 25.6989C21.0432 25.5504 21.3906 25.3825 21.7535 25.1934C24.661 23.6799 27.9637 21.1443 31.0539 18.054C34.1442 14.9638 36.6798 11.6611 38.1933 8.7536C38.3818 8.39074 38.5504 8.04398 38.6988 7.71146C39.4123 6.11724 39.6822 4.8646 39.6822 3.88317C39.6823 2.62084 39.2361 1.80597 38.715 1.28493Z",
    fill: "url(#paint10_linear_715_336)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_336",
    x1: 12.3697,
    y1: 13.5,
    x2: 39.4804,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#26A6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_715_336",
    x1: 18.986,
    y1: 13.5,
    x2: 39.7641,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01BFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2539,
    stopColor: "#1F9EFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5724,
    stopColor: "#407AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8326,
    stopColor: "#5464FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_715_336",
    x1: 12.9134,
    y1: 18.5699,
    x2: 28.5651,
    y2: 18.5699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#46CC8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AB69F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_715_336",
    x1: 18.7176,
    y1: 22.5311,
    x2: 27.9117,
    y2: 22.5311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46CC8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    stopColor: "#0AB69F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01998D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_715_336",
    x1: 22.5824,
    y1: 6.16765,
    x2: 38.2022,
    y2: 6.16765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#46CC8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AB69F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_715_336",
    x1: 24.9108,
    y1: 6.16765,
    x2: 38.2767,
    y2: 6.16765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46CC8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    stopColor: "#0AB69F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01998D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_715_336",
    x1: 28.9909,
    y1: 12.0313,
    x2: 33.6335,
    y2: 12.0313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46CC8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    stopColor: "#0AB69F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01998D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_715_336",
    x1: 14.8,
    y1: 9.00586,
    x2: 19.3839,
    y2: 9.00586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#46CC8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AB69F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_715_336",
    x1: 30.9471,
    y1: 20.4825,
    x2: 38.2623,
    y2: 20.4825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#46CC8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AB69F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_715_336",
    x1: 33.0953,
    y1: 20.4825,
    x2: 38.5716,
    y2: 20.4825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46CC8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    stopColor: "#0AB69F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01998D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_715_336",
    x1: 12.6823,
    y1: 13.5002,
    x2: 38.902,
    y2: 13.5002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#FFE177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB137"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48095511);
export default __webpack_public_path__ + "static/media/Group 48095511.c59b2e450778a2ec0651984649a3b930.svg";
export { ForwardRef as ReactComponent };